<template>
  <BaseLink
    class="button typography__body2"
    :class="social"
    :href="url ?? createAuthLink(social)"
  >
    <BaseIcon2
      :id="`icon-${SOCIALS[social].icon}`"
      class="button-icon"
      sprite="socials"
    />

    {{ SOCIALS[social].name }}
  </BaseLink>
</template>

<script lang="ts" setup>
const props = defineProps<Props>();
const { project, redirectTo, accessToken } = toRefs(props);
const config = useRuntimeConfig();
const { $env, $i18n } = useNuxtApp();

type Project = "crm" | "cv";

type Social = "google" | "mailru" | "telegram" | "vk" | "yandex";

interface Props {
  project: Project;
  redirectTo: string;
  social: Social;
  url?: string;
  accessToken?: string;
}

interface SocialParameters {
  name: string;
}

const createAuthLink = (social: Social) => {
  const baseUrl = $env.isDev ? "http://mydonut.local" : config.public.baseUrl;
  const [protocol, host] = baseUrl.split("://");

  // Проверяем, есть ли уже протокол в redirectTo
  let finalRedirectTo = redirectTo.value;
  if (redirectTo.value && !redirectTo.value.startsWith("http://") && !redirectTo.value.startsWith("https://")) {
    // Если протокола нет - добавляем базовый URL
    finalRedirectTo = `${protocol}://${host}${redirectTo.value.startsWith("/") ? "" : "/"}${redirectTo.value}`;
  }
  // Если протокол есть - используем как есть

  let authUrl = `${protocol}://api-${project.value}.${host}/auth/${social}?redirect_to=${encodeURIComponent(finalRedirectTo)}`;

  // Добавляем токен если он передан
  if (accessToken?.value) {
    authUrl += `&access_token=${accessToken.value}`;
  }

  return authUrl;
};

const SOCIALS: Record<Social, SocialParameters> = {
  google: {
    icon: "google",
    name: $i18n.t("common.social.google"),
  },
  mailru: {
    icon: "mailru-blue",
    name: $i18n.t("common.social.mailru"),
  },
  telegram: {
    icon: "telegram",
    name: $i18n.t("common.social.telegram"),
  },
  vk: {
    icon: "vk",
    name: $i18n.t("common.social.vk"),
  },
  yandex: {
    icon: "yandex",
    name: $i18n.t("common.social.yandex"),
  },
};
</script>

<style scoped>
.button {
  display: flex;
  column-gap: 8px;
  padding: 8px 24px;
  border-radius: 8px;
  background-color: var(--grey-7);
}

.button.mailru {
  background-color: #0069fe;
  color: var(--white);
}

.button-icon {
  width: 24px;
  height: 24px;
}
</style>
